module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "segments-page"
  }, [_c('div', {
    class: _vm.pageLoading ? 'hidden' : ''
  }, [_c('x-table', {
    attrs: {
      "title": _vm.$t('ui.segments.segments'),
      "columns": _vm.columns,
      "tableData": _vm.segments,
      "enableSearch": true,
      "enableFilter": false,
      "totalResults": _vm.totalCount,
      "pagination": _vm.defaultPagination,
      "showLoader": _vm.loading,
      "actions": _vm.actions,
      "actionsLocation": "row",
      "rowsAreClickable": true,
      "tableSettingsName": "segments"
    },
    on: {
      "updatePagination": _vm.updatePagination,
      "fetchData": _vm.fetchData,
      "clickRow": _vm.actionEdit
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "segments-page-loader",
    class: _vm.pageLoading ? '' : 'hidden'
  }, [_c('loading')], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "title": _vm.$t('ui.segments.duplicate_modal.title'),
      "saveText": _vm.$t('ui.segments.duplicate_modal.duplicate'),
      "open": _vm.duplicateSegmentModalOpen
    },
    on: {
      "save": function($event) {
        return _vm.duplicateSegment()
      },
      "cancel": function($event) {
        return _vm.closeDuplicateSegmentModal()
      }
    }
  }, [_c('field', {
    attrs: {
      "label": _vm.$t('ui.segments.duplicate_modal.name'),
      "autofocus": true
    },
    model: {
      value: (_vm.duplicateSegmentName),
      callback: function($$v) {
        _vm.duplicateSegmentName = $$v
      },
      expression: "duplicateSegmentName"
    }
  })], 1), _vm._v(" "), _c('modal', {
    attrs: {
      "open": _vm.deleteSegmentModalOpen,
      "title": _vm.$t('ui.segments.delete_modal.title'),
      "type": "warning",
      "showCancelForWarning": true,
      "saveText": _vm.$t('ui.global.delete')
    },
    on: {
      "save": _vm.deleteSegment,
      "cancel": _vm.closeDeleteSegmentModal
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('ui.global.delete_confirmation', {
    name: this.currentSegment ? this.currentSegment.name : ''
  })))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7d4928d0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/segments/Segments.vue
// module id = 1956
// module chunks = 0